import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_PATHS } from 'config.js';

const JudgeNavLogo = () => {
  return (
    <div className="logo position-relative">
      <Link to={DEFAULT_PATHS.JUDGE}>
        <div className="logo-nav" />
      </Link>
    </div>
  );
};
export default React.memo(JudgeNavLogo);
